// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import { Avatar, Box, IconButton, MenuItem, Select, Typography, useMediaQuery } from '@mui/material';
// import { useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import theme from '../../../theme';
// import Layout from './Layout';
// import { reducerPaths } from '../../../app/reducerPaths';
// const UserHeader = ({
//   userRole = ""
// }) => {
//   const { t, i18n } = useTranslation('header');
//   const auth = useSelector((store) => store[reducerPaths.auth]);
//   // useState start
//   const [language, setLanguage] = useState(i18n.language === 'en' ? 'ENG' : 'FR');
//   const [anchorEl, setAnchorEl] = useState(null);
//   // useState end

//   const isMobile = useMediaQuery('(max-width:900px)');

//   const handleLanguageMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLanguageChange = (newLanguage) => {
//     setLanguage(newLanguage);
//     i18n.changeLanguage(newLanguage === 'ENG' ? 'en' : 'fr');
//     handleLanguageMenuClose();
//   };

//   function stringAvatar(name) {
//     if (!name) return { children: '' };
//     if (name.includes(' '))
//       return {
//         children: `${name?.split(' ')[0][0]}${name?.split(' ')[1][0]}`,
//       };
//     else
//       return {
//         children: `${name?.split(' ')[0][0]}`,
//       };
//   }

//   const UserHeaderContent = () => (
//     <Box
//       sx={{
//         position: 'sticky',
//         top: 0,
//         zIndex: 1000,
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         px: '24px',
//         m: '12px 0 0 0',
//         backgroundColor: '#f5f5f5',
//         width: '100%',
//         boxSizing: 'border-box',
//       }}
//     >
//       {/* Welcome Message */}
//       <Box>
//         <Typography
//           variant="h6"
//           component="div"
//           color="textDisabled"
//           sx={{
//             fontSize: { xs: '1.2rem', sm: '1.5rem', md: '2rem' },
//             fontWeight: 400,
//           }}
//         >
//           Welcome{' '}
//           <Typography
//             component="span"
//             sx={{
//               fontSize: { xs: '1.2rem', sm: '1.5rem', md: '2rem' },
//               fontWeight: 600,
//               color: 'text.primary',
//             }}
//           >
//             Back!
//           </Typography>
//         </Typography>
//       </Box>

//       {/* Profile Icon with Language Select */}
//       <Box
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           gap: { xs: 0.5, sm: 1, md: 1.5 },
//         }}
//       >
//         <Box>
//           <Select
//             value={language}
//             onChange={(e) => handleLanguageChange(e.target.value)}
//             displayEmpty
//             sx={{
//               height: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
//               width: { xs: 80, sm: 90, md: 100 },
//               color: theme.palette.text.primary,
//               border: `none`,
//               fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
//               '& .MuiSelect-select': {
//                 color: theme.palette.text.primary,
//                 padding: { xs: '0.25rem', sm: '0.375rem', md: '0.5rem' },
//               },
//               '& .MuiSelect-icon': {
//                 color: theme.palette.text.primary,
//               },
//               outline: 'none',
//               '& .MuiOutlinedInput-notchedOutline': {
//                 border: 'none',
//               },
//             }}
//             MenuProps={{
//               PaperProps: {
//                 sx: {
//                   backgroundColor: theme.palette.background.paper,
//                   color: theme.palette.text.secondary,
//                   '& .MuiMenuItem-root': {
//                     backgroundColor: 'transparent',
//                     color: theme.palette.text.secondary,
//                     fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
//                     '&:hover': {
//                       backgroundColor: 'transparent',
//                     },
//                   },
//                 },
//               },
//             }}
//           >
//             <MenuItem value="ENG">
//               <Typography sx={{ color: `${theme.palette.text.primary}` }}>ENG</Typography>
//             </MenuItem>
//             <MenuItem value="FR">
//               <Typography sx={{ color: theme.palette.text.primary }}>FR</Typography>
//             </MenuItem>
//           </Select>
//         </Box>
//         <Avatar
//           {...stringAvatar(auth?.user_name)}
//           alt={auth?.user_name}
//           src={auth?.profilePic}
//           sx={{
//             fontSize: `${20 / 16}rem`,
//             width: '50px',
//             height: '50px',
//             border: `2px solid #23262C`,
//           }}
//         />
//         <Typography
//           variant="caption"
//           color="textPrimary"
//           sx={{
//             marginRight: { xs: '0.25rem', sm: '0.375rem', md: '0.5rem' },
//             fontSize: `${20 / 16}rem`,
//             fontWeight: 400,
//           }}
//         >
//           {auth?.user_name}
//           <br />
//           {userRole}
//         </Typography>
//       </Box>
//     </Box>
//   );

//   return isMobile ? (
//     <Layout>
//       <UserHeaderContent />
//     </Layout>
//   ) : (
//     <UserHeaderContent />
//   );
// };

// export default UserHeader;
////////////////////////////////////////////

import { Avatar, Box, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Select, Tooltip, Typography, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { reducerPaths } from 'src/app/reducerPaths';
import theme from '../../../theme';

export const headerHeight = '70px';

const UserHeader = ({ onMenuClick, showMenuButton = false, userRole = "" }) => {

  const isMobile = useMediaQuery('(max-width:900px)');

  const auth = useSelector((store) => store[reducerPaths.auth]);

  const { t, i18n } = useTranslation('userHeader');

  // useState start
  const [language, setLanguage] = useState(i18n.language === 'en' ? 'ENG' : 'FR');
  // useState end

  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
    i18n.changeLanguage(newLanguage === 'ENG' ? 'en' : 'fr');
  };

  function stringAvatar(name) {
    if (!name) return { children: '' };
    if (name.includes(' '))
      return {
        children: `${name?.split(' ')[0][0]}${name?.split(' ')[1][0]}`,
      };
    else
      return {
        children: `${name?.split(' ')[0][0]}`,
      };
  }

  const UserHeaderContent = () => (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: '12px 24px',
        backgroundColor: '#ebebeb',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      {/* Left Section: Menu Button + Welcome Message */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          minWidth: 0,
          gap: 1,
        }}
      >
        {/* Menu Button for Mobile/Tablet */}
        {/* {showMenuButton && (
          <IconButton
            onClick={onMenuClick}
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: 'white',
              width: { xs: 36, sm: 40, md: 44 },
              height: { xs: 36, sm: 40, md: 44 },
              flexShrink: 0,
              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
              },
            }}
          >
            <MenuIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' } }} />
          </IconButton>
        )} */}

        {/* Welcome Message */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            mr: 2,
          }}
        >
          <Tooltip title={`${t('welcome')} ${t('back')}!`} arrow>
            <Typography
              variant="h6"
              component="div"
              color="textDisabled"
              sx={{
                fontSize: { xs: '1rem', sm: '1.5rem', md: '2rem' },
                fontWeight: 400,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: { xs: 'nowrap', md: 'normal' },
              }}
            >
              {t('welcome')}{' '}
              <Box
                component="span"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.5rem', md: '2rem' },
                  fontWeight: 600,
                  color: 'text.primary',
                }}
              >
                {t('back')}!
              </Box>
            </Typography>
          </Tooltip>
        </Box>
      </Box>

      {/* Profile Section - RIGHT SIDE */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 0.5, sm: 1, md: 1.5 },
          flexShrink: 0,
        }}
      >
        <Box>
          <Select
            value={language}
            onChange={(e) => handleLanguageChange(e.target.value)}
            displayEmpty
            sx={{
              height: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
              width: { xs: 80, sm: 90, md: 100 },
              color: theme.palette.text.primary,
              border: `none`,
              fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
              '& .MuiSelect-select': {
                color: theme.palette.text.primary,
              },
              '& .MuiSelect-icon': {
                color: theme.palette.text.primary,
              },
              outline: 'none',
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  backgroundColor: theme.palette.background.paper,
                  color: theme.palette.text.secondary,
                  '& .MuiMenuItem-root': {
                    backgroundColor: 'transparent',
                    color: theme.palette.text.secondary,
                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="ENG">
              <Typography sx={{ color: `${theme.palette.text.primary}` }}>ENG</Typography>
            </MenuItem>
            <MenuItem value="FR">
              <Typography sx={{ color: theme.palette.text.primary }}>FR</Typography>
            </MenuItem>
          </Select>
        </Box>
        <Tooltip title={auth?.user_name || ''} arrow>
          <Avatar
            {...stringAvatar(auth?.user_name)}
            alt={auth?.user_name}
            src={auth?.profilePic}
            sx={{
              fontSize: { xl: `${20 / 16}rem`, xs: `${16 / 16}rem` },
              width: { xl: '50px', xs: '40px' },
              height: { xl: '50px', xs: '40px' },
              border: `2px solid #23262C`,
            }}
          />
        </Tooltip>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            variant="caption"
            color="textPrimary"
            sx={{
              display: { xs: 'none', sm: 'block' },
              textWrap: 'nowrap',
              fontSize: { xl: `${20 / 16}rem`, xs: `${16 / 16}rem` },
              fontWeight: 400,
            }}
          >
            {auth?.user_name}
          </Typography>

          <span
            style={{
              fontSize: '0.8rem',
              fontWeight: 500,
            }}
          >
            {userRole}
          </span>
        </Box>

        {/* Dropdown Menu */}
        <Menu
          id="profile-menu"
          // anchorEl={anchorEl}
          // open={open}
          // onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'profile-button',
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          sx={{
            mt: 1,
            '& .MuiPaper-root': {
              minWidth: 180,
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              borderRadius: 2,
            },
          }}
        >
          <MenuItem 
            // onClick={handleViewProfile}
          >
            <ListItemIcon>
              <PersonIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('viewProfile')}</ListItemText>
          </MenuItem>

          <MenuItem 
            // onClick={handleSettings}
          >
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('settings')}</ListItemText>
          </MenuItem>

          <Divider />

          <MenuItem 
            // onClick={handleLogout}
          >
            <ListItemIcon>
              <LogoutIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText sx={{ color: 'error.main' }}>{t('logout')}</ListItemText>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );


  return isMobile ? (
      <UserHeaderContent 
        userRole={userRole}
      />
  ) : (
    <UserHeaderContent 
      userRole={userRole}
    />
  );
};

// const UserHeader = ({
//   userRole = ""
// }) => {
//   const isMobile = useMediaQuery('(max-width:900px)');

//   return isMobile ? (
//     <Layout>
//       <UserHeaderContent 
//         userRole={userRole}
//       />
//     </Layout>
//   ) : (
//     <UserHeaderContent 
//       userRole={userRole}
//     />
//   );
// };

export default UserHeader;